<script setup lang="ts">
import { computed } from "vue";
import TextFieldWithIconGroup from "@/components/molecules/form/TextFieldWithIconGroup.vue";
import ValidationProvider from "@/components/organisms/validation/ValidationProvider.vue";

const props = defineProps({
  modelValue: {
    type: String,
    default: ""
  },
  name: {
    type: String,
    default: "パスワード"
  },
  label: {
    type: String,
    default: ""
  },
  placeholder: {
    type: String,
    default: "パスワード"
  },
  hideHelpText: {
    type: Boolean,
    default: false
  },
  strict: {
    type: Boolean,
    default: undefined
  },
  requiredOnly: {
    type: Boolean,
    default: false
  },
  vid: {
    type: String,
    default: "password"
  },
  helpText: {
    type: String,
    default: "半角英数字を組み合わせて8文字以上で設定してください"
  }
});

const emit = defineEmits(["input"]);

const inputValue = computed({
  get: (): string => props.modelValue,
  set: (value: string) => emit("input", value)
});
const rules = computed((): string => {
  if (props.requiredOnly) {
    return "required";
  }
  let rule = "required|min:8|max:500";
  if (props.strict) {
    rule += "|include_hankaku_english|include_hankaku_number";
  }
  return rule;
});
</script>

<template>
  <ValidationProvider
    :vid="vid"
    v-slot="{ errors, meta, handleChange }"
    :name="name"
    :rules="rules"
    tag="div"
  >
    <TextFieldWithIconGroup
      v-model="inputValue"
      :label="label"
      type="password"
      :validation-state="{ errors, valid: meta.valid }"
      showPasswordToggle
      @input="value => handleChange(value)"
      class="sentry-mask glay-password"
    />
    <p v-if="!hideHelpText" class="help-text text-size-12">
      {{ helpText }}
    </p>
  </ValidationProvider>
</template>

<style scoped lang="scss">
.glay-password :deep(input) {
  background-color: #e5e5e5;
}
</style>
